import script from "./SavesView.vue?vue&type=script&setup=true&lang=js"
export * from "./SavesView.vue?vue&type=script&setup=true&lang=js"

import "./SavesView.vue?vue&type=style&index=0&id=0d8f34ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d8f34ca"]])

export default __exports__